import React from 'react';
import Modal from './Modal';
import Button from './Button';
import useCopy from '../util/useCopy';
import PopcornIcon from './PopcornIcon';

const SpectatorModal = ({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: () => void;
}) => {
  let copy = useCopy();

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="flex flex-1 flex-col items-start justify-end px-5">
        <PopcornIcon className="mb-2 h-8 w-8 text-neutral-500" />
        <div className="text-xl font-bold">{copy.spectatorMode}</div>
      </div>
      <div className="flex-1 px-5">
        <p className="mt-2 text-left text-sm text-neutral-600">
          {copy.spectatorModeExplanation}
        </p>
      </div>
      <Modal.BottomActions>
        <Button onClick={onClose}>OK</Button>
      </Modal.BottomActions>
    </Modal>
  );
};

export default SpectatorModal;
